"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterBlankAttributes = void 0;
/**
 * Determines if any value is not blank.
 * @param i A value to test for blank.
 */
var notBlank = function (i) {
    switch (typeof i) {
        case 'undefined':
            return false;
        case 'boolean':
            return true;
        case 'string':
            return i.length > 0;
        case 'number':
            return true;
        case 'object':
            return i !== null;
        default:
            return i;
    }
};
/**
 * Returns any nested blank values from an array. Otherwise simply returns the item.
 * @param item The item to test.
 */
var filterNestedBlankValues = function (item) {
    try {
        return typeof item === 'object'
            ? item.filter
                ? item.filter(function (i) { return notBlank(i); }) // filter non-null values in a nested array
                : (0, exports.filterBlankAttributes)(item) // recursively process a nested object
            : item;
    }
    catch (e) {
        // tslint:disable no-console
        console.log('Could not filter non-null attribute for item:');
        console.log(item);
        console.log('----------------------------------');
        console.log(e);
        // tslint:enable no-console
        return item;
    }
};
/**
 * Removes any blank attributes from an object.
 * @param item An object to filter any blank values.
 */
var filterBlankAttributes = function (item) {
    return Object.keys(item)
        .filter(function (k) { return notBlank(item[k]); })
        .reduce(function (p, k) {
        var _a;
        return (__assign(__assign({}, p), (_a = {}, _a[k] = filterNestedBlankValues(item[k]), _a)));
    }, {});
};
exports.filterBlankAttributes = filterBlankAttributes;
